'use strict';

import { createHtmlElement } from '../../functions';
import { getCurrentLangDirection, isDesktopMode } from '../language/langSwitcher';
import gsap from "gsap";

export function bottomNavBarInit () {
  const mainContainer = createHtmlElement(document.body,'','div',['bottom__nav-bar']);

  animateBottomNavBar(mainContainer);

  return mainContainer;
}

export function animateBottomNavBar (container) {
  const langDirection = getCurrentLangDirection();
  let side = langDirection === 'ltr' ? 'right' : 'left';
  const importantDirection = isDesktopMode();

  switch (importantDirection) {
    case 'rtl':
      side = 'left';
      break;
    case 'ltr':
      break;
  }

  gsap.fromTo(container,{[side]: -200, opacity:0 },{[side]:32, duration: 1, opacity: 1,onComplete:()=>{
    resetBottomNavBarAnimation(container);
    }});
}

function resetBottomNavBarAnimation (container) {
  container.style.removeProperty('left');
  container.style.removeProperty('right');
}